import styled from 'styled-components';

export const StyledEventProfileSummary = styled.div``;
